export default __webpack_public_path__ + "static/Workout-With-A-View-Yoga-Retreat-India-07a1bdda138a61e53f53a56f9f9c8c5b.jpg";